module.exports = __webpack_public_path__ + "static/media/ciel-grenoble.b5a2bac8.png";